import { InnerBox } from "@/components/elements/InnerBox";
import { Stack } from "@mui/material";
import { FC, useState, useMemo, useEffect } from "react";
import { DashboardProvider } from "@/features/dashboard/providers/DashboardProvider";
import { TopAlert } from "@/features/dashboard/components/TopAlert";
import { Notification } from "@/components/commons/notification/Notification";
import { DashboardStatistics } from "@/features/dashboard/components/DashboardStatistics";
import { DashboardInitialSetup } from "@/features/dashboard/components/DashboardInitialSetup";
import { DashboardRecentOfferAccepted } from "@/features/dashboard/components/DashboardRecentOfferAccepted";
import { useGetMatchInfo } from "@/api/services/main/match";
import { useMe } from "@/api/services/main/auth";

type TDashboardPageProps = {};

export const DashboardPage: FC<TDashboardPageProps> = () => {
  const { data: matchInfoResult } = useGetMatchInfo();
  const { data: meResult } = useMe();

  const matchId = meResult?.data?.matchId;
  const isIrohanaSupport = meResult?.data?.isMatchUser === false;

  const getIrohanaTutorialHiddenKey = (matchId: number) => `irohana_tutorial_hidden_${matchId}`;

  const [isLocallyHidden, setIsLocallyHidden] = useState(() => {
    if (typeof window === "undefined") return false;
    return false;
  });

  useEffect(() => {
    if (isIrohanaSupport && matchId) {
      const storedValue = localStorage.getItem(getIrohanaTutorialHiddenKey(matchId));
      if (storedValue === "true") {
        setIsLocallyHidden(true);
      }
    }
  }, [isIrohanaSupport, matchId]);

  const shouldShowTutorial = useMemo(() => {
    if (isIrohanaSupport && isLocallyHidden) return false;
    if (!isIrohanaSupport && matchInfoResult?.data?.isTutorialHidden) return false;

    return true;
  }, [isLocallyHidden, matchInfoResult, isIrohanaSupport]);

  const handleHideTutorial = () => {
    if (isIrohanaSupport && matchId) {
      localStorage.setItem(getIrohanaTutorialHiddenKey(matchId), "true");
      setIsLocallyHidden(true);
    }
  };

  return (
    <DashboardProvider>
      <Stack gap={4}>
        <TopAlert />
        {shouldShowTutorial && <DashboardInitialSetup onHide={handleHideTutorial} />}
        <DashboardStatistics />
        <DashboardRecentOfferAccepted />
        <InnerBox title="お知らせ" variantTitle="head20Bold" bordered={false} showDivider={false}>
          <Notification isHideContent={true} />
        </InnerBox>
      </Stack>
    </DashboardProvider>
  );
};
